import { createFileRoute, Outlet } from '@tanstack/react-router'

import { defaultRoomSearch, roomSearchSchema } from '@/pages/deals/search-schema'
import { store } from '@/store'
import { buildOAuthRedirectUrl } from '@/utils/helpers'

export const Route = createFileRoute('/_layout/_private')({
  component: Outlet,
  validateSearch: (search) => roomSearchSchema.catch(defaultRoomSearch).parse(search),
  loaderDeps: ({ search }) => {
    return {
      search,
    }
  },
  loader: ({ location }) => {
    const state = store.getState()

    if (!state.isInitialized) {
      return null
    }

    if (!store.getState().isAuthorized) {
      const backUrl = location.pathname + (location.hash ? `#${location.hash}` : '')
      window.location.href = buildOAuthRedirectUrl(backUrl)
    }

    if (state.isAuthorized && state.user && !state.termsAccepted) {
      window.location.href = '/login/oauth/start?type=oauth'
    }
  },
})
